export {
  LicensedProductsSection,
  type LicensedProductsSectionProps,
} from './LicensedProductsSection';
